import SoundCloudWidgetComponent from '@wix/thunderbolt-elements/src/components/SoundCloudWidget/viewer/SoundCloudWidget';
import SoundCloudWidgetController from '@wix/thunderbolt-elements/src/components/SoundCloudWidget/viewer/SoundCloudWidget.controller';


const SoundCloudWidget = {
  component: SoundCloudWidgetComponent,
  controller: SoundCloudWidgetController
};


export const components = {
  ['SoundCloudWidget']: SoundCloudWidget
};

